import React from "react";
import MaterialChip from "@mui/material/Chip";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  root: {
    marginRight: "5px",
  },
  outlined: {
    border: (props) => `1px solid ${props.textcolor}`,
    backgroundColor: "transparent !important",
  },
  icon: {
    color: (props) => (props.variant === "outlined" ? props.textcolor : "white"),
  },
  deleteIcon: {
    color: (props) => (props.variant === "outlined" ? props.textcolor : "white"),
  },
}));

const Chip = (props) => {
  const { classes } = useStyles(props);

  return (
    <MaterialChip
      {...props}
      classes={{
        root: classes.root,
        outlined: classes.outlined,
        icon: classes.icon,
        deleteIcon: classes.deleteIcon,
      }}
    />
  );
};

export default Chip;
